module.exports = __webpack_public_path__ + "static/img/10.c8088c90.png";